//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import vComponent from '@/core/vComponent'
import ScrollBar from '@/components/ScrollBar'
import { removeLocal } from '@/utils/globalState'
export default {
  components: { ScrollBar },
  extends: vComponent,
  data () {
    return {
      activeIndex: 0
    }
  },
  computed: {
    ...mapGetters([
      'menuData',
      'siteData',
      'isLogin',
      'stock_no',
      'site',
      'theme'
    ]),
    permission_routers () {
      return this.$router.options.routes
    },
    isCollapse () {
      return false
      // return !this.sidebar.opened
    },
    allowMenuData () {
      const conf = this.siteData[`site_${this.site}`] ? this.siteData[`site_${this.site}`] : this.siteData[`site_default`]
      const result = []
      this.menuData.sideBar.forEach(item => {
        if (conf.allowLink.indexOf(item.link) !== -1) result.push(item)
      })
      return result
    },
    items () {
      let result = []
      this.allowMenuData.forEach(item => {
        if (this.isLogin) {
          result.push(item)
        } else {
          if (!item.login) result.push(item)
        }
      })
      return result
    },
    stock_no_str () {
      return this.stock_no !== null && this.stock_no !== undefined ? this.stock_no : '尚未設定'
    },
    bgColor () {
      return `bg-${this.theme}-4`
    },
    textColor () {
      return `text-sidebar`
      // return `text-${this.theme}-invert`
    }
  },
  created () {
    this.items.forEach((item, index) => {
      // 所有vip/下的連結都放在viplist下一起顯示
      if (this.$route.path.indexOf(item.link) !== -1) {
        this.activeIndex = index
      } else if (this.$route.path.indexOf('vip') !== -1 && item.link.indexOf('vip') !== -1) {
        this.activeIndex = index
      }
    })
  },
  mounted () {

  },
  methods: {
    clickLink (link, index) {
      this.activeIndex = index
      this.to(link)
    },
    clickCleanBtn () {
      // localStorage.clear()
      // location.reload()
      removeLocal('token')
      this.to('login')
    }
  }
}
